// SPDX-License-Identifier: AGPL-3.0-or-later

import {getDataFlx} from '@app/features/ui/components/icons/BrandImageUtils';
import lafonLoMaskUrl from '@app/media/images/lafon-lo-mask.png';
import type React from 'react';

type LafonLoIconProps = Omit<React.HTMLAttributes<HTMLSpanElement>, 'children'> & {
	className?: string;
};

/**
 * Monochrome LafON "lo" mark. Painted via CSS mask from `color` / `currentColor`
 * so it tracks theme `--brand-primary` (and selected/hover fill).
 */
export function LafonLoIcon({className, style, ...props}: LafonLoIconProps) {
	return (
		<span
			aria-hidden
			className={className}
			{...props}
			style={{
				display: 'block',
				flexShrink: 0,
				backgroundColor: 'currentColor',
				WebkitMaskImage: `url(${lafonLoMaskUrl})`,
				maskImage: `url(${lafonLoMaskUrl})`,
				WebkitMaskSize: 'contain',
				maskSize: 'contain',
				WebkitMaskRepeat: 'no-repeat',
				maskRepeat: 'no-repeat',
				WebkitMaskPosition: 'center',
				maskPosition: 'center',
				...style,
			}}
			data-flx={getDataFlx(props, 'ui.icons.lafon-lo-icon.span')}
		/>
	);
}
